/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { describeStep } from './mavenParse';

/** What Maven is doing right now, in its own voice, e.g. "I'm running a query…". */
const MavenWorking = ({ steps }) => (
  <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.75, fontStyle: 'italic' }}>
    I&apos;m {steps.length ? describeStep(steps[steps.length - 1]) : 'thinking it through'}…
  </Typography>
);

MavenWorking.propTypes = { steps: PropTypes.arrayOf(PropTypes.string).isRequired };

export default MavenWorking;
